/* import __COLOCATED_TEMPLATE__ from './group-details-modal.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';
import type { ScimGroup, ScimUser, Role, DropdownGroup } from './types';
import type { SelectGroup } from 'embercom/utils/teammates/role-dropdown-utils';

interface Args {
  isVisible: boolean;
  selectedGroup: ScimGroup | null;
  groupChanges: Record<string, number | null>;
  availableRoles: Role[];
  isLoadingGroupDetails: boolean;
  hasCurrentGroupChanges: boolean;
  isLoading: boolean;
  canDeactivate: boolean;
  onClose: () => void;
  onApplyCurrentGroupChanges: () => void;
  onDeactivateGroup: () => void;
  getGroupPriority: (group: ScimGroup) => string;
  getUserInitials: (user: ScimUser) => string;
  getGroupStateDisplayName: (state: string | null) => string;
  getGroupStateColor: (state: string | null) => 'green' | 'gray';
  modalRoleDropdownList: DropdownGroup[];
  currentModalRoleName: string;
  modalRoleSelectGroupList: SelectGroup[];
  currentModalRoleObject: Role | null;
  onSelectModalRole: (role: Role | null) => void;
  isLoadingUserGroups: boolean;
  isCurrentUserMember: boolean;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
  Blocks: {};
}

const ScimGroupDetailsModal = templateOnlyComponent<Signature>();
export default ScimGroupDetailsModal;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::GroupDetailsModal': typeof ScimGroupDetailsModal;
    'new-settings/workspace/teammates/scim/group-details-modal': typeof ScimGroupDetailsModal;
  }
}
